import React from 'react'

const DropdownButton = ({ onClick, isOpen, isUpdating, currentDisplay, disabled = false }) => (
  <button
    onClick={onClick}
    disabled={disabled || isUpdating}
    className="w-full bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-4 py-3 text-left hover:bg-white/20 transition-all duration-300 flex items-center justify-between disabled:opacity-50 disabled:cursor-not-allowed"
    style={{color: 'var(--theme-text-primary)'}}
  >
    <div className="flex items-center gap-3">
      <div
        className="w-4 h-4 rounded-full"
        style={{ backgroundColor: 'var(--theme-primary)' }}
      ></div>
      <span>{isUpdating ? 'Updating...' : currentDisplay}</span>
    </div>
    <ChevronIcon isOpen={isOpen} />
  </button>
)

export const ChevronIcon = ({ isOpen }) => (
  <svg
    className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
)

export default DropdownButton